export default "__VITE_ASSET__J_xaK7GO__"